import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'textarea' };

class FormTextarea extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-form__input',
            className,
        ];
    }

    renderChildren() {
        return undefined;
    }

}

FormTextarea.propTypes = propTypes;

FormTextarea.defaultProps = defaultProps;

export default FormTextarea;
